/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAvatarCircle = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12 6C9.808 6 8 7.75 8 9.947s1.808 3.948 4 3.948 4-1.75 4-3.948C16 7.751 14.192 6 12 6zm-2 3.947C10 8.888 10.879 8 12 8s2 .888 2 1.947c0 1.06-.879 1.948-2 1.948s-2-.889-2-1.948z" />
        <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zM4 12a8 8 0 1 1 14.058 5.226 5.012 5.012 0 0 0-1.515-1.351c-1.151-.68-2.668-1.033-4.543-1.033s-3.392.354-4.543 1.032c-.627.37-1.13.828-1.515 1.352A7.97 7.97 0 0 1 4 12zm3.442 6.575a2.96 2.96 0 0 1 1.031-.978c.752-.443 1.886-.755 3.527-.755 1.64 0 2.775.312 3.527.755a2.94 2.94 0 0 1 1.03.978C15.266 19.474 13.695 20 12 20s-3.265-.526-4.558-1.425z" />
      </g>
    </g>
  </Icon>
);
export { SvgAvatarCircle as AvatarCircle };
